// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1GYYa","content":"Consent_content__15dCL","footer":"Consent_footer__1o3hr"};